<template>
  <div class="shop-sync-page">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>店铺同步配置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar">
      <div><h3>店铺同步配置</h3><p>维护商品排名同步使用的店铺与站点。</p></div>
      <el-button v-perm="'product:shopSync:save'" type="primary" size="small" icon="el-icon-plus" @click="openEdit()">新增配置</el-button>
    </div>
    <el-form :inline="true" :model="filters" size="small" @submit.native.prevent="search">
      <el-form-item label="店铺 / 卖家 / 站点">
        <el-input v-model="filters.keyword" placeholder="请输入名称或 ID" clearable maxlength="128" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.enabled" placeholder="全部" clearable>
          <el-option label="启用" :value="true" /><el-option label="禁用" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="search">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" v-loading="loading" border stripe size="small" row-key="id" empty-text="暂无店铺同步配置">
      <el-table-column prop="id" label="ID" width="75" />
      <el-table-column prop="shopName" label="店铺名称" min-width="150" show-overflow-tooltip />
      <el-table-column prop="sellerId" label="卖家 ID" min-width="150" show-overflow-tooltip />
      <el-table-column prop="marketplaceId" label="站点 ID" min-width="150" show-overflow-tooltip />
      <el-table-column label="执行器" min-width="175" show-overflow-tooltip>
        <template slot-scope="s">{{ executorAddress(s.row) }}</template>
      </el-table-column>
      <el-table-column label="区域" width="110"><template slot-scope="s">{{ regionLabel(s.row.amazonEndpoint) }}</template></el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="s"><el-tag size="mini" :type="s.row.enabled ? 'success' : 'info'">{{ s.row.enabled ? '启用' : '禁用' }}</el-tag></template>
      </el-table-column>
      <el-table-column label="更新时间" min-width="160"><template slot-scope="s">{{ formatTime(s.row.updateTime) }}</template></el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template slot-scope="s">
          <el-button v-perm="'product:shopSync:save'" type="text" size="small" :disabled="!!busyRows[s.row.id]" @click="openEdit(s.row)">编辑</el-button>
          <el-button v-perm="'product:shopSync:save'" type="text" size="small" :disabled="!!busyRows[s.row.id]" @click="toggleEnabled(s.row)">{{ s.row.enabled ? '禁用' : '启用' }}</el-button>
          <el-button v-perm="'product:shopSync:delete'" type="text" size="small" class="danger" :disabled="!!busyRows[s.row.id]" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" background :current-page="currentPage" :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]" :total="total" layout="total, sizes, prev, pager, next"
      @current-change="changePage" @size-change="changeSize" />

    <el-dialog :title="editing.id ? '编辑店铺同步配置' : '新增店铺同步配置'" :visible.sync="editVisible" width="660px"
      :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving">
      <el-alert title="保存配置不会立即执行同步；新配置默认禁用，请核对店铺和站点后再启用。" type="info" :closable="false" show-icon class="form-tip" />
      <el-form ref="editForm" :model="editing" :rules="rules" label-width="135px" size="small" :disabled="saving" @submit.native.prevent="save">
        <el-form-item label="店铺名称" prop="shopName"><el-input v-model="editing.shopName" maxlength="128" show-word-limit /></el-form-item>
        <el-row :gutter="16">
          <el-col :span="15"><el-form-item label="执行器 IP" prop="proxyIp"><el-input v-model="editing.proxyIp" placeholder="例如 192.168.31.10" maxlength="64" /></el-form-item></el-col>
          <el-col :span="9"><el-form-item label="端口" prop="proxyPort" label-width="70px"><el-input-number v-model="editing.proxyPort" :min="1" :max="65535" :precision="0" controls-position="right" style="width:100%" /></el-form-item></el-col>
        </el-row>
        <el-form-item label="卖家 ID" prop="sellerId"><el-input v-model="editing.sellerId" maxlength="64" /></el-form-item>
        <el-form-item label="站点 ID" prop="marketplaceId"><el-input v-model="editing.marketplaceId" placeholder="例如美国站 ATVPDKIKX0DER" maxlength="64" /></el-form-item>
        <el-form-item label="Amazon 区域" prop="amazonEndpoint">
          <el-select v-model="editing.amazonEndpoint" style="width:100%"><el-option v-for="region in regions" :key="region.value" :label="region.label" :value="region.value" /></el-select>
          <div class="field-tip">选择与站点对应的区域。取该站点所有排名中的最小值，仅同步 1～100000 范围内的排名。</div>
        </el-form-item>
        <el-form-item label="状态"><el-switch v-model="editing.enabled" active-text="启用" inactive-text="禁用" /></el-form-item>
      </el-form>
      <div slot="footer"><el-button size="small" :disabled="saving" @click="editVisible = false">取消</el-button><el-button size="small" type="primary" :loading="saving" @click="save">保存</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/request/shopSyncModules";
import { blankConfig, savePayload, regionOptions, validIp } from "./shopSyncModel";

const required = label => ({ required: true, whitespace: true, message: `请输入${label}`, trigger: "blur" });
export default {
  data() {
    return {
      rows: [], total: 0, currentPage: 1, pageSize: 20, loading: false, loadSequence: 0,
      filters: { keyword: "", enabled: "" }, busyRows: {},
      editVisible: false, editing: blankConfig(), saving: false, regions: regionOptions,
      rules: {
        shopName: [required("店铺名称")], sellerId: [required("卖家 ID")], marketplaceId: [required("站点 ID")],
        amazonEndpoint: [required("Amazon 区域")],
        proxyIp: [{ validator: (rule, value, done) => done(validIp(value) ? undefined : new Error("请输入有效的 IP，不带协议或端口")), trigger: "blur" }],
        proxyPort: [{ type: "number", required: true, min: 1, max: 65535, message: "端口范围为 1～65535", trigger: "change" }],
      },
    };
  },
  created() { this.load(); },
  beforeDestroy() { this.loadSequence++; },
  methods: {
    async load() {
      const sequence = ++this.loadSequence;
      this.loading = true;
      try {
        const result = await api.page({ currentPage: this.currentPage, pageSize: this.pageSize, keyword: this.filters.keyword.trim(),
          enabled: typeof this.filters.enabled === "boolean" ? this.filters.enabled : undefined });
        if (sequence !== this.loadSequence) return;
        this.rows = result.data.records || []; this.total = result.data.total || 0;
        if (!this.rows.length && this.currentPage > 1) { this.currentPage--; return this.load(); }
      } catch (e) { if (sequence === this.loadSequence) this.$message.error(e.message || "加载配置失败"); }
      finally { if (sequence === this.loadSequence) this.loading = false; }
    },
    search() { this.currentPage = 1; return this.load(); },
    resetSearch() { this.filters = { keyword: "", enabled: "" }; return this.search(); },
    changePage(page) { this.currentPage = page; return this.load(); },
    changeSize(size) { this.pageSize = size; return this.search(); },
    openEdit(row) {
      this.editing = row ? savePayload(row) : blankConfig(); this.editVisible = true;
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    async save() {
      if (this.saving) return;
      const valid = await new Promise(resolve => this.$refs.editForm.validate(resolve));
      if (!valid || this.saving) return;
      this.saving = true;
      try {
        await api.save(savePayload(this.editing)); this.$message.success("配置已保存"); this.editVisible = false; await this.load();
      } catch (e) { this.$message.error(e.message || "保存失败"); }
      finally { this.saving = false; }
    },
    async toggleEnabled(row) {
      if (this.busyRows[row.id]) return;
      this.$set(this.busyRows, row.id, true);
      try {
        await api.setEnabled(row.id, !row.enabled); this.$message.success(row.enabled ? "已禁用" : "已启用"); await this.load();
      } catch (e) { this.$message.error(e.message || "状态更新失败"); }
      finally { this.$delete(this.busyRows, row.id); }
    },
    async remove(row) {
      if (this.busyRows[row.id]) return;
      this.$set(this.busyRows, row.id, true);
      try {
        await this.$confirm(`确认删除“${row.shopName}”的同步配置？删除后将不再参与后续同步。`, "删除配置", { type: "warning", confirmButtonText: "删除", cancelButtonText: "取消" });
        await api.remove(row.id); this.$message.success("配置已删除"); await this.load();
      } catch (e) { if (e !== "cancel" && e !== "close") this.$message.error((e && e.message) || "删除失败"); }
      finally { this.$delete(this.busyRows, row.id); }
    },
    regionLabel(endpoint) { const item = regionOptions.find(r => r.value === endpoint); return item ? item.label : endpoint; },
    executorAddress(row) { return row.proxyIp.includes(":") ? `[${row.proxyIp.replace(/[\[\]]/g, "") }]:${row.proxyPort}` : `${row.proxyIp}:${row.proxyPort}`; },
    formatTime(value) { return value ? new Date(value).toLocaleString("zh-CN", { hour12: false }) : "—"; },
  },
};
</script>

<style scoped>
.shop-sync-page { padding: 20px; background: #fff; min-height: 100%; }
.breadcrumb { margin-bottom: 20px; }
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.toolbar h3 { margin: 0 0 6px; }
.toolbar p, .field-tip { color: #909399; font-size: 12px; margin: 0; }
.form-tip { margin-bottom: 20px; }
.pagination { margin-top: 18px; text-align: right; }
.danger { color: #f56c6c; }
</style>
